import { useMemo, useEffect } from 'react'
import { useFetch, useIsInView } from '@cvg/react-hooks'

import { useFiltersContext } from '@contexts/FilterContext'
import { getEntries, getEntriesCacheKey } from '@services/entries'

export const useHomeData = () => {
  const { filters, sortBy } = useFiltersContext()

  const {
    data = [],
    isLoading,
    isValidating,
    error,
    setSize
  } = useFetch(getEntries, {
    pagination: {
      getCacheKey: (index, previousData) => getEntriesCacheKey(index, previousData, { filters, sortBy })
    },
    swrOptions: {
      revalidateFirstPage: false
    }
  })

  const entries = useMemo(() => data.flatMap(page => page.entries), [data])

  const { total = 0 } = data[0] || {}
  const hasMoreEntries = entries.length < total

  const { isInView, observerRef } = useIsInView({ rootMargin: '0px 0px 800px 0px' })

  useEffect(() => {
    if (hasMoreEntries && isInView) setSize(previousSize => previousSize + 1)
  }, [isInView])

  return {
    entries,
    error,
    hasMoreEntries,
    isLoading,
    isValidating,
    observerRef,
    total
  }
}
